import React from 'react'
import WarningIcon from '@mui/icons-material/Warning'
import {stornoColor} from 'module/Storno/util/StornoStyle'
import {css} from '@emotion/react'

const cssStornoIcon = css`
	color: ${stornoColor};
	height: 15px;
	width: 15px;
	float: left;
`

export function StornoIconComponent() {
	return <WarningIcon css={cssStornoIcon}/>
}
